import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { QueryClient, QueryClientProvider } from "react-query";
import OnAir from "./OnAir";
import OnAirSessionProvider from "./contexts/Session";
var queryClient = new QueryClient();
var OnAirPage = function(param) {
    var isEmbedded = param.isEmbedded, jwt = param.jwt, sessionRegistrationId = param.sessionRegistrationId, webinarId = param.webinarId, sessionCountryCode = param.sessionCountryCode;
    return /*#__PURE__*/ _jsx(QueryClientProvider, {
        client: queryClient,
        children: /*#__PURE__*/ _jsx(OnAirSessionProvider, {
            isEmbedded: isEmbedded,
            jwt: jwt,
            sessionRegistrationId: sessionRegistrationId,
            sessionCountryCode: sessionCountryCode,
            children: /*#__PURE__*/ _jsx(OnAir, {
                isEmbedded: isEmbedded,
                webinarId: webinarId
            })
        })
    });
};
export default OnAirPage;
